import { connect } from 'react-redux'
import MarketoImport from 'components/Imports/MarketoImport'
import { showTransientNotification } from '@driftt/traffic-control'

const mapDispatchToProps = dispatch => {
  return {
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(null, mapDispatchToProps)(MarketoImport)
